function c(t) {
  return t.getRootNode() instanceof ShadowRoot;
}
function a(t) {
  return c(t) ? t.getRootNode() : document;
}
function d(t) {
  if (!t) return;
  const e = t.querySelector(
    'input, select, textarea, button, a[href], [tabindex]:not([tabindex="-1"])'
  );
  if (e instanceof HTMLElement && e.offsetParent !== null && e.getBoundingClientRect().width > 0)
    e.focus();
  else {
    const n = t.querySelector('[tabindex="-1"]');
    n instanceof HTMLElement && n.offsetParent !== null && n.getBoundingClientRect().width > 0 ? n.focus() : (t.setAttribute("tabindex", "0"), t.focus());
  }
}
function b(t) {
  if (!t) return () => {
  };
  const e = "$el" in t ? t.$el : t, n = a(e), u = (o) => {
    if (o.key !== "Tab") return;
    const s = Array.from(
      e.querySelectorAll(
        'input, select, textarea, button, a[href], [tabindex]:not([tabindex="-1"])'
      )
    ).filter((r) => !r.hasAttribute("disabled") && r.offsetParent !== null), f = s[0], i = s[s.length - 1], l = n.activeElement;
    o.shiftKey ? l === f && (o.preventDefault(), i.focus()) : l === i && (o.preventDefault(), f.focus());
  };
  return e.addEventListener("keydown", u), u;
}
export {
  d as f,
  b as t
};
//# sourceMappingURL=focus.YB4BM1B3.js.map
